import DeleteOutline from "@mui/icons-material/DeleteOutline";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import { Box, Grid, Typography } from "@mui/material";
import { FC } from "react";
import { HeadingFormElement } from "../../../../types";
import FormElementTaskDescription from "../../../form-builder/FormElementTaskDescription";

type TaskHeadingFormComponentProps = HeadingFormElement & {
  nested?: boolean;
  disabled?: boolean;
  removeNestedComponent?: () => void;
  required?: boolean; // for use with field definition components
  skipped?: boolean;
};

const TaskHeadingFormComponent: FC<TaskHeadingFormComponentProps> = ({
  id,
  headingType,
  label,
  name,
  description,
  nested,
  removeNestedComponent,
  required,
  ...props
}) => {
  if (
    (props.hide == true && !props.disabled) ||
    (props.hideInSummary && props.disabled)
  )
    return;
  return (
    <Grid id={id}>
      <Box
        sx={(theme) => ({
          display: "flex",
          padding: 1,
          alignItems: "center",
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        })}
      >
        {nested && <SubdirectoryArrowRightIcon sx={{ mr: 1 }} />}
        <Typography
          sx={(theme) => ({
            color: theme.palette.getContrastText(theme.palette.grey[300]),
          })}
          variant={headingType || "h4"}
          id={name}
        >
          {label}
          {props.skipped === true && (
            <Box
              component="span"
              sx={(t) => ({
                ml: 1,
                px: 1,
                py: 0.25,
                borderRadius: "8px",
                backgroundColor: t.palette.primary.dark,
                color: t.palette.primary.contrastText,
                fontWeight: 600,
                display: "inline-block",
                verticalAlign: "middle",
              })}
            >
              <Typography variant={"body2"}>NONE</Typography>
            </Box>
          )}
          {required && (
            <Typography sx={{ display: "inline", color: "red", ml: 0.0 }}>
              *
            </Typography>
          )}
        </Typography>
        {nested && removeNestedComponent && (
          <>
            <Grid flex={1} />
            <DeleteOutline
              sx={{ mr: 1, cursor: "pointer" }}
              onClick={() => {
                removeNestedComponent();
              }}
            />
          </>
        )}
      </Box>

      <FormElementTaskDescription variant="body1">
        {description}
      </FormElementTaskDescription>
    </Grid>
  );
};

export default TaskHeadingFormComponent;
